import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c709fffe&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c709fffe&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=c709fffe&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c709fffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c709fffe')) {
      api.createRecord('c709fffe', component.options)
    } else {
      api.reload('c709fffe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c709fffe&scoped=true&", function () {
      api.rerender('c709fffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rawMaterials/index.vue"
export default component.exports